var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 40,
    viewBox: "0 0 51 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(-451 -96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(451 96)",
    fill: "#fff",
    stroke: "rgba(157,173,188,0.36)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 40,
    rx: 2.13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 50,
    height: 39,
    rx: 1.63,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4158",
    transform: "translate(488 -385.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon9",
    d: "M324.305,512.141h-2.964l1.854-11.462h2.964Z",
    transform: "translate(-339.451 -5.471)",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M461.9,495.488a7.3,7.3,0,0,0-2.658-.488c-2.927,0-4.988,1.561-5,3.792-.024,1.646,1.476,2.561,2.6,3.11,1.147.561,1.536.927,1.536,1.427-.012.768-.927,1.122-1.78,1.122a5.9,5.9,0,0,1-2.781-.61l-.39-.183-.415,2.573a9.02,9.02,0,0,0,3.305.61c3.11,0,5.134-1.537,5.158-3.914.012-1.3-.78-2.3-2.488-3.122-1.037-.524-1.671-.878-1.671-1.415.012-.488.537-.988,1.707-.988a5.035,5.035,0,0,1,2.208.439l.268.122.4-2.475Z",
    transform: "translate(-466.305 0)",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M682.941,508.081c.244-.658,1.183-3.207,1.183-3.207-.012.024.244-.671.39-1.1l.207.988s.561,2.744.683,3.317Zm3.658-7.4h-2.293a1.462,1.462,0,0,0-1.549.951l-4.4,10.511h3.11l.622-1.719h3.805c.085.4.354,1.719.354,1.719h2.744L686.6,500.679Z",
    transform: "translate(-683.404 -5.471)",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M60.987,500.679l-2.9,7.816-.317-1.585a8.773,8.773,0,0,0-4.1-4.8l2.659,10.024h3.134l4.659-11.45Z",
    transform: "translate(-81.572 -5.471)",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M-26.183,500.679h-4.768l-.049.232a9.917,9.917,0,0,1,7.2,6l-1.037-5.268a1.226,1.226,0,0,0-1.341-.964Z",
    transform: "translate(0 -5.471)",
    fill: "#faa61a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.3de36d2e80b9c2613646b8a3a9c81769.svg";
export { ForwardRef as ReactComponent };